import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard'; // Import the AuthGuard
import { LoginComponent } from './modules/login/login.component'; 

const routes: Routes = [
  //{ path: '', redirectTo: 'timesheet/timesheet-n', pathMatch: 'full' },  // Default route to login
  { path: '', component: LoginComponent },
  { path: 'Login', component: LoginComponent },
  //{ path: 'change', loadChildren: () => import('./modules/change-password/change-password.module').then((m) => m.ChangePasswordModule), canActivate: [AuthGuard] },
  { path: 'changePassword', loadChildren: () => import('./modules/change-password/change-password.module').then((m) => m.ChangePasswordModule)},
  { path: 'home', loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule), canActivate: [AuthGuard] },
  { path: 'allProjects', loadChildren: () => import('./modules/all-projects/all-projects.module').then((m) => m.AllProjectsModule), canActivate: [AuthGuard] },
  { path: 'calendar', loadChildren: () => import('./modules/calendar/calendar.module').then((m) => m.CalendarModule) , canActivate: [AuthGuard] },
  { path: 'resources', loadChildren: () => import('./modules/resources/resources.module').then((m) => m.ResourcesModule) , canActivate: [AuthGuard] },
  { path: 'timesheet', loadChildren: () => import('./modules/timesheet/timesheet.module').then((m) => m.TimesheetModule), canActivate: [AuthGuard] },
  { path: 'users', loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule) , canActivate: [AuthGuard] },
  { path: 'report', loadChildren: () => import('./modules/report/report.module').then(m => m.ReportModule) , canActivate: [AuthGuard] },
  { path: 'masterdata', loadChildren: () => import('./modules/master-data/master-data.module').then((m) => m.MasterDataModule) , canActivate: [AuthGuard] },
  { path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule) },
  { path: 'Admin', redirectTo: 'admin', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
